import DOMPurify from "dompurify";
import { marked } from "marked";

const hasMarkdownSyntax = (content) =>
  /(^|\n)\s{0,3}(?:#{1,6}\s+|[-+*]\s+|\d+\.\s+)|\*\*[^*]+\*\*|`[^`]+`/m.test(content);

const unwrapMarkdownContainers = (content) =>
  content
    .replace(/<br\s*\/?\s*>/gi, "\n")
    .replace(/<(?:p|div|h[1-6]|ul|ol|pre|blockquote)[^>]*>/gi, "")
    .replace(/<\/(?:p|div|h[1-6]|ul|ol|pre|blockquote)>/gi, "\n")
    .replace(/<li[^>]*>/gi, "- ")
    .replace(/<\/li>/gi, "\n");

export function convertMarkdownToHtml(markdown) {
  if (!markdown) return "";

  const markdownContent = hasMarkdownSyntax(markdown)
    ? unwrapMarkdownContainers(markdown)
    : markdown;

  return DOMPurify.sanitize(marked.parse(markdownContent));
}
